// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GiftCardAmount_container__N2AYu {
  display: flex;

  flex-direction: column;
  justify-content: flex-start;
  font-family: "Avenir LT Std 45 Book";

}

.GiftCardAmount_heading__xsUcu {
  color: rgba(4, 37, 82, 1);
  font-size: 18px;
  font-weight: 700;
  line-height: 29px;
  margin-bottom: 8px;
}

.GiftCardAmount_amountGrid__cijFS {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: 10px;
}

.GiftCardAmount_amountButton__mJyd5 {
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: calc(50% - 8px);
  border-radius: 4px;
  padding: 8px;
  font-size: 14px;
  border: 1px solid rgba(185, 185, 185, 1);
  background: none;
  color: rgba(0, 0, 0, 1);
  cursor: pointer;
    transition: all 0.3s ease;
    height: 32px !important;
    padding: 8px !important;
   line-height: normal !important;
   font-family: "Avenir LT Std 45 Book";
}

.GiftCardAmount_amountButton__mJyd5:hover {
  background-color: rgba(4, 37, 82, 0.1);
}

.GiftCardAmount_amountButton__mJyd5:focus {
  outline: none;
}

.GiftCardAmount_amountButton__mJyd5:focus-visible {
  box-shadow: 0 0 0 3px rgba(4, 37, 82, 0.2);
  outline: none;
}

.GiftCardAmount_amountButton__mJyd5.GiftCardAmount_selected__nrrZf {
  color: rgba(255, 255, 255, 1);
  border-color: #115ba0;
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: calc(50% - 8px);
  border-radius: 4px;
  padding: 8px;
}




.GiftCardAmount_customAmount__S4GNO {
  flex-basis: 100%;
  border-radius: 4px;
  padding: 8px;
  border: 1px solid rgba(185, 185, 185, 1);
  width: 100%;
  color: black;
  transition: border-color 0.3s ease;
  font-family: "Avenir LT Std 45 Book";
  min-width: 200px;

}

.GiftCardAmount_customAmount__S4GNO.GiftCardAmount_valid__5MQrD {
  border-color: #115ba0;
  box-shadow: 0 0 0 1px #115ba0;
}

.GiftCardAmount_customAmount__S4GNO.GiftCardAmount_invalid__BZB8- {
  border-color: #dc3545;
  box-shadow: 0 0 0 1px #dc3545;
}

.GiftCardAmount_customAmount__S4GNO:focus {
  outline: none;
  border-color: #115ba0;
  box-shadow: 0 0 0 2px rgba(17, 91, 160, 0.25);
}`, "",{"version":3,"sources":["webpack://./src/modules/Home/Step1/GiftCardAmount.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;;EAEb,sBAAsB;EACtB,2BAA2B;EAC3B,oCAAoC;;AAEtC;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,YAAyB;EAAzB,cAAyB;EAAzB,2BAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,wCAAwC;EACxC,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;IACb,yBAAyB;IACzB,uBAAuB;IACvB,uBAAuB;GACxB,8BAA8B;GAC9B,oCAAoC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,YAAyB;EAAzB,cAAyB;EAAzB,2BAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;;;;AAKA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;EACxC,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,oCAAoC;EACpC,gBAAgB;;AAElB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C","sourcesContent":[".container {\n  display: flex;\n\n  flex-direction: column;\n  justify-content: flex-start;\n  font-family: \"Avenir LT Std 45 Book\";\n\n}\n\n.heading {\n  color: rgba(4, 37, 82, 1);\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 29px;\n  margin-bottom: 8px;\n}\n\n.amountGrid {\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.amountButton {\n  flex: 1 0 calc(50% - 8px);\n  border-radius: 4px;\n  padding: 8px;\n  font-size: 14px;\n  border: 1px solid rgba(185, 185, 185, 1);\n  background: none;\n  color: rgba(0, 0, 0, 1);\n  cursor: pointer;\n    transition: all 0.3s ease;\n    height: 32px !important;\n    padding: 8px !important;\n   line-height: normal !important;\n   font-family: \"Avenir LT Std 45 Book\";\n}\n\n.amountButton:hover {\n  background-color: rgba(4, 37, 82, 0.1);\n}\n\n.amountButton:focus {\n  outline: none;\n}\n\n.amountButton:focus-visible {\n  box-shadow: 0 0 0 3px rgba(4, 37, 82, 0.2);\n  outline: none;\n}\n\n.amountButton.selected {\n  color: rgba(255, 255, 255, 1);\n  border-color: #115ba0;\n  flex: 1 0 calc(50% - 8px);\n  border-radius: 4px;\n  padding: 8px;\n}\n\n\n\n\n.customAmount {\n  flex-basis: 100%;\n  border-radius: 4px;\n  padding: 8px;\n  border: 1px solid rgba(185, 185, 185, 1);\n  width: 100%;\n  color: black;\n  transition: border-color 0.3s ease;\n  font-family: \"Avenir LT Std 45 Book\";\n  min-width: 200px;\n\n}\n\n.customAmount.valid {\n  border-color: #115ba0;\n  box-shadow: 0 0 0 1px #115ba0;\n}\n\n.customAmount.invalid {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 1px #dc3545;\n}\n\n.customAmount:focus {\n  outline: none;\n  border-color: #115ba0;\n  box-shadow: 0 0 0 2px rgba(17, 91, 160, 0.25);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GiftCardAmount_container__N2AYu`,
	"heading": `GiftCardAmount_heading__xsUcu`,
	"amountGrid": `GiftCardAmount_amountGrid__cijFS`,
	"amountButton": `GiftCardAmount_amountButton__mJyd5`,
	"selected": `GiftCardAmount_selected__nrrZf`,
	"customAmount": `GiftCardAmount_customAmount__S4GNO`,
	"valid": `GiftCardAmount_valid__5MQrD`,
	"invalid": `GiftCardAmount_invalid__BZB8-`
};
export default ___CSS_LOADER_EXPORT___;
